import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import PhoneInput from 'react-phone-number-input'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import Alert from '../../../../_metronic/partials/alert'
import { trim } from '../../../../_metronic/helpers'
import { fetchStartWithForward } from '../../../../redux/actions/common'
import { setPartnerSubStep } from '../redux/actions'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { parsePhoneNumberWithError } from 'libphonenumber-js/max'
import { scrollToErros } from '../../loanApplication/steps/Step1Sub1'

const Step1Sub0: FC<any> = ({ sendOTP, setMobileNo }: any) => {
  const dispatch = useDispatch()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg] = useState<string>('')
  const [alertType] = useState<any>('primary')

  const handleCreateApplication = () => {
    dispatch(setPartnerSubStep(1))
  }

  const initialValues = {
    mobileNumber: '',
  }

  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .test('mobileValidation', 'Please enter valid Singapore number', (value: any) => {
        if (!value) return false
        // Use libphonenumber-js to validate phone number format
        const number = parsePhoneNumberWithError(value, 'SG')
        // Use libphonenumber-js to validate phone number format
        return (
          isValidPhoneNumber(value, 'SG') &&
          number.isValid() &&
          number.country === 'SG' &&
          number.country === 'SG'
        )
      }),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const { mobileNumber } = trim(values)
      setMobileNo(mobileNumber)
      dispatch(fetchStartWithForward())
      sendOTP({
        variables: {
          mobileNo: mobileNumber,
          isApplicantOrShareholder: true,
          isCoApplicantKYB: false,
        },
      })
      setSubmitting(false)
    },
  })

  return (
    <div className='d-flex flex-column flex-column-fluid'>
      <div className='cardNew'>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className='row mb-10'>
            <div className='col-md-12'>
              <label htmlFor='' className='input-field-label required'>
                Mobile Number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileNumber'
                  international
                  defaultCountry='SG'
                  // countryCallingCodeEditable={false}
                  value={formik.values.mobileNumber}
                  onChange={(value: any) => formik.setFieldValue('mobileNumber', value)}
                  placeholder='Enter phone number'
                  className='int-phone-input'
                />
                {(formik.touched.mobileNumber || formik.values.mobileNumber === undefined) &&
                  formik.errors.mobileNumber && (
                    <div className='text-danger mt-2'>{formik.errors.mobileNumber}</div>
                  )}
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-between'>
            <button
              type='button'
              className='button button-primary me-3'
              onClick={() => handleCreateApplication()}
            >
              Create new application
            </button>
            <button
              type='submit'
              className='button button-primary'
              onClick={() => {
                scrollToErros()
              }}
            >
              Send OTP
            </button>
          </div>
        </form>
      </div>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export { Step1Sub0 }
